import { Attachment } from '@docma-mm-core/attachment/attachment';
import { ViewFault } from '@docma-mm-core/fault/fault';
import { MmModel } from '@docma-mm-core/model/mm.model';
import { Structure } from '@docma-mm-core/structure/structure';
import { BehaviorSubject } from 'rxjs';
import { PlanDto } from '../../bp-common/models/plan';
import { BpPin } from '../../bp-common/models/bp-pin';

export class PlanData {
  Id?: string;
  Size?: number;
  MimeType?: string;
  FileName?: string;
  Description?: string;
  Comment?: string;
  Date?: string;
  Type?: number;
  VisibleFor?: number;
  EditableFor?: number;
  IsActive?: boolean;
  IsEnabledOnMobile?: boolean;
  IsLocalizable?: boolean;
  PlanVersion?: PlanVersion;
  Structure?: Structure;
  StructurePath?: string;
  Remark?: string;
  BpPlan?: PlanDto;
  ModifiedOn?: string;
}


export class PlanVersion {
  Id?: number;
  SUid?: string;
  Plan?: any;
  FileId?: number;
  Version?: number;
  ScaleX?: number;
  ScaleY?: number;
  TransformX?: number;
  TransformY?: number;
  Rotation?: number;
  CreatedOn?: string;
  ModifiedOn?: string;
}

export class Plan extends MmModel<PlanData> {
  private _pins = new BehaviorSubject<Array<FaultPin>>([]);
  public pins$ = this._pins.asObservable();

  private _metaData = new BehaviorSubject<PlanMetadata>(null);
  public metaData$ = this._metaData.asObservable();

  attachment: Attachment;
  selectedPins: number;

  get pins(): FaultPin[] {
    return this._pins.value;
  }

  set pins(p: FaultPin[]) {
    // console.debug(p, 'plan - ### plans set ### 01 - _pins.next (1)');
    this._pins.next(p);
  }

  addPin(pin: FaultPin) {
    const pinsInternal = this._pins.value;
    pinsInternal.push(pin);
    // console.debug(pinsInternal, 'plan - ### plans set ### 01 - _pins.next (2)');
    this._pins.next(pinsInternal);
  }

  get metaData(): PlanMetadata {
    return this._metaData.value;
  }

  set metaData(p: PlanMetadata) {
    this._metaData.next(p);
  }


}

export interface FaultPin {
  fault?: ViewFault;
  coordinate?: Coordinate;
  bpPin?: BpPin;
}

export class Coordinate {
  FileId?: number;
  PosX?: number;
  PosY?: number;
  RelativeAnchorToParentPosX?: number;
  RelativeAnchorToParentPosY?: number;
}

export class PlanMetadata {
  TileSize: number;
  MaxZoomLevel: number;
  ImageHeight: number;
  ImageWidth: number;
  TilesUrl?: string;
  TaskId?: string;
  IsLocalMode: boolean = false;
  MaxNativeZoom?: number;
}
